import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import AuroraConsultingScreenshot from './img/screenshots/Aurora-Consulting.png';
import VKDesignsScreenshot from './img/screenshots/VK-Designs.png';
import Figure8Screenshot from './img/screenshots/Figure-8-Creative.png';
import TuraScreenshot from './img/screenshots/Tura-IO.png';
import adriftScreenshot from './img/screenshots/Adrift-Hotel.png';
import codeShot from './img/code-shot.jpg';

const graphicLime = <a href="http://www.graphiclime.com" target="_blank" rel="noopener noreferrer">Graphic Lime Creative</a>;
const zoePDX = <a href="https://zoepdx.com/" target="_blank" rel="noopener noreferrer">ZoePDX</a>;
const foundation6 = <a href="https://foundation.zurb.com/sites.html" target="_blank" rel="noopener noreferrer">Foundation 6</a>;
const wooCommerce = <a href="https://woocommerce.com/" target="_blank" rel="noopener noreferrer">WooCommerce</a>;
const adriftHotelLink = <a href="https://www.adrifthotel.com/" target="_blank" rel="noopener noreferrer">Adrift Hotel + Spa</a>;
const discoveryCoastLink = <a href="http://www.innatdiscoverycoast.com/" target="_blank" rel="noopener noreferrer">The Inn at Discovery Coast</a>;
const shelburneHotelLink = <a href="https://shelburnehotelwa.com/" target="_blank" rel="noopener noreferrer">Shelburne Hotel</a>;
const ashoreHotelLink = <a href="https://www.ashorehotel.com/" target="_blank" rel="noopener noreferrer">Ashore Hotel</a>;
const distillersLink = <a href="https://adriftdistillers.com/" target="_blank" rel="noopener noreferrer">Adrift Distillers</a>;

export class Portfolio extends Component {
	render() {
		return (
			<div className="portfolio-container">
				<h1>Portfolio</h1>
				<PortfolioItem screenShot={AuroraConsultingScreenshot} >
					<h2><span className="pi-tags">Web Development</span><a href="https://www.auroraconsult.com/" target="_blank" rel="noopener noreferrer">Aurora Consulting</a></h2>
					<p>Custom WordPress theme developed from mockups by {graphicLime} for Minneapolis based firm, Aurora Consulting. This site was built for frequent content additions by the client, and is designed to be flexible and attractive to their audience.</p>
				</PortfolioItem>
				<PortfolioItem screenShot={adriftScreenshot} >
					<h2><span className="pi-tags">Web Development</span><a href="https://www.adrifthotel.com/" target="_blank" rel="noopener noreferrer">Adrift Hotel + Spa</a></h2>
					<p>
						Full-custom WordPress theme developed from designs by {zoePDX} for {adriftHotelLink}. We built this theme to be used not only for the
						Adrift Hotel site, but also to be modified for their other hotels and businesses; {discoveryCoastLink}, {shelburneHotelLink}, &nbsp;
						{ashoreHotelLink}, and {distillersLink}.
					</p>
				</PortfolioItem>
				<PortfolioItem screenShot={VKDesignsScreenshot} >
					<h2><span className="pi-tags">Web Development</span><a href="https://www.vkdesignsjewelry.com/" target="_blank" rel="noopener noreferrer">VK Designs Jewelry</a></h2>
					<p>VK Designs is a Portland jewelery studio. I developed a custom WordPress theme based on designs by {graphicLime}, using the {foundation6} framework and {wooCommerce}</p>
				</PortfolioItem>
				<ImageBanner src={codeShot} />
				<PortfolioItem screenShot={Figure8Screenshot} >
					<h2><span className="pi-tags">Web Development</span><a href="https://www.figure8creative.com/" target="_blank" rel="noopener noreferrer">Figure 8 Creative</a></h2>
					<p>Marketing and branding agency in Portland, Oregon. WordPress theme from designs provided by Figure 8, including custom tile sorting algorithm, Magic 8-Ball functionality, and highly user-customizable content.</p>
				</PortfolioItem>
				<PortfolioItem screenShot={TuraScreenshot} >
					<h2><span className="pi-tags">Web Design & Web Development</span><a href="http://www.tura.io/" target="_blank" rel="noopener noreferrer">Tura.io</a></h2>
					<p>Custom theme design & development for a Portland, OR based big-data startup. I worked closely with the client to build a site that would succinctly represent a complex product, and be attractive for investors.</p>
				</PortfolioItem>
			</div>
		)
	}
};

const PortfolioItem = (props) => {
	return (
		<div className="portfolio-item">
			<div className="pi-column">
				<DesktopScreenshot src={props.screenShot} />
			</div>
			<div className="pi-column pi-description">
				{props.children}
			</div>
		</div>
	);
}

const DesktopScreenshot = (props) => {
	return (
		<div className="desktop-screenshot">
			<div className="ds-screen-outer">
				<div className="ds-screen-inner"><img src={props.src} alt="Portfolio Item Screenshot"/></div>
				<span className="ds-screen-logo" />
			</div>
			<div className="ds-pedestal" />
			<div className="ds-pedestal-bottom" />
		</div>
	)
}

class ImageBanner extends Component {
		render(props) {
			const divStyle = {
				backgroundImage: `url(${this.props.src})`
			};
			return (
				<div className="image-banner" style={divStyle} />
			)
		}
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/Portfolio.js